import { Component, OnDestroy, OnInit } from '@angular/core';
import { DataGenericComponent } from '../data-generic/data-generic.component';

@Component({
  selector: 'app-data-sketch-fab',
  templateUrl: './data-sketch-fab.component.html',
  styleUrls: ['./data-sketch-fab.component.scss']
})
export class DataSketchFabComponent extends DataGenericComponent implements OnInit, OnDestroy {
  public row = 0;

  ngOnInit(): void {
    super.ngOnInit();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}
